// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"99106c75","283":"a82a5a93","455":"a82a5a93","584":"f955bd4b","632":"3be0ba31","794":"eb98ec86","898":"e0ae165b","950":"614627dc"}[chunkId] + ".chunk.css";
};